import React from "react";
import AutoSaveModel from "../models/auto.save.model";

const useDrafts = () => {
    const [drafts, setDrafts] = React.useState<any[]>([]);

    const getDrafts = async () => {
        const api = new AutoSaveModel();
        await api.openDb();

        const items = await api.getDrafts();
        setDrafts(items);
    }

    const deleteDraft = async (id: number) => {
        const api = new AutoSaveModel();
        await api.openDb();
        await api.deleteDraft(id);
        await getDrafts();
    }

    return {
        drafts,
        getDrafts,
        deleteDraft,
    }
}
export default useDrafts;